import { ViewReport2 } from './reports-view/view-report_2'
import { ViewReport13 } from './reports-view/view-report_13'
import ViewVoucherRedemption from './reports-view/view-report_voucher_redemption'

const REPORTS_OPTIONS = [
  {
    name: 'Merchant Transaction Summary (Report 2)',
    link: '?modal=report_2',
    type: 'report_2',
  },
  {
    name: 'Merchant Transaction (Report 13)',
    link: '?modal=report_13',
    type: 'report_13',
  },
  {
    name: 'Voucher Redemption Count',
    link: '?modal=voucher_redemption',
    type: 'voucher_redemption',
  },

] as const

export type ReportOptionsTypesType =
  | (typeof REPORTS_OPTIONS)[number]['type']
  | undefined

type ReportOptionType = (typeof REPORTS_OPTIONS)[number] | null

export const ReportsViewResults = ({
  reportType,
}: {
  reportType: ReportOptionsTypesType
}) => {
  return (
    <>
      {/* <div className="flex flex-col gap-4 w-max">
        {REPORTS_OPTIONS.map((item) => (
          <button
            key={item.name}
            className="px-3 py-1 border rounded-md border-primary text-primary"
            type="button"
          >
            <Link to={item.link} className="flex items-center gap-2">
              <CreateIcon size={16} />
              <span className="tracking-wider font-light">{item.name}</span>
            </Link>
          </button>
        ))}
      </div> */}

      {/* REPORT 2 */}
      {reportType === 'report_2' && <ViewReport2 />}

      {/* REPORT 13 */}
      {reportType === 'report_13' && <ViewReport13 />}

      {/* Voucher Redemption */}
      {reportType === 'voucher_redemption' && <ViewVoucherRedemption />}
    </>
  )
}
